import React from 'react'
import './section-new-line.scss'

import CardFeature from '../../molecules/card-feature/card-feature'
import { graphql, useStaticQuery } from 'gatsby'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from '@contentful/rich-text-types'

const SectionNewLine = () => {
  const { allContentfulVConfidentHome } = useStaticQuery(
    graphql`
      query newLine {
        allContentfulVConfidentHome {
          nodes {
            node_locale
            paisesDeRestriccion
            tituloLineasNosotras {
              raw
            }
            caracteristicasLineaNosotras {
              descripcinComponente {
                raw
              }
              imagenComponente {
                description
                file {
                  url
                }
              }
            }
          }
        }
      }
    `
  )

  const optiondRender = {
    renderNode: {
      [BLOCKS.HEADING_2]: (node, next) => (
        <h2 className="f-section-new-line__title">{next}</h2>
      ),
    },
  }

  const contentInfo = allContentfulVConfidentHome.nodes.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0]

  return (
    <section className="f-section-new-line">
      <div className="f-section-new-line__wrapper">
        <div className="f-section-new-line__content">
          {documentToReactComponents(
            JSON.parse(contentInfo.tituloLineasNosotras.raw),
            optiondRender
          )}
          <div className="f-section-new-line__features">
            {contentInfo.caracteristicasLineaNosotras.map((feature, index) => {
              return (
                <CardFeature
                  key={`feature-${index + 1}`}
                  image={feature.imagenComponente[0]}
                  txt={feature.descripcinComponente}
                />
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SectionNewLine
